const Colors = {
    headerNavigationRed: '#E4002B',
    headerNavigationRed2: '#E4002B',
    sidebarNavigationRed: '#B3001E',
    backgroundGray: '#737373',
    backgroundRed: '#85001A',
    backgroundWhite: '#FFFFFF',
    backgroundBlue: '#092041',
    footerRed: '#E4002B',
    tiers: {
        tier1: '#ECECEC',
        tier2: '#C8C8C8',
        tier3: '#807F83',
        defaultRed: '#B3001E',
        defaultGray: '#737373',
        defaultBlue: '#092041',
        defaultWhite: '#FFFFFF',
    },
    loader: '#ECECEC',
    loaderHighlight: '#C8C8C8',
    fontGray: '#737373',
    fontWhite: '#FFFFFF'
};

export default Colors;
